import { StatelessComponent } from 'react'
import * as cn from 'classnames'
import * as styles from 'styles/molecules/CategoriesListMobile.css'
import { CategoryId } from 'interfaces/meta'
import { CategoryItem } from 'components/molecules/CategoriesList'
import { ALL_CATEGORY_ID } from 'constants/meta'

export type CategoriesListProps = {
  itemsMember: CategoryItem[]
  itemsPeers: CategoryItem[]
  itemsOthers: CategoryItem[]
  withComparison: boolean
  onClickItem?: (id: CategoryId | null) => void
}

const CategoriesList: StatelessComponent<CategoriesListProps> =
  ({ itemsMember, itemsPeers, itemsOthers, onClickItem, withComparison }: CategoriesListProps) => (
    <>
      { itemsMember.map(({ id, categoryName, isShaded, isSelected }, idx) => {
        const isTotal = id === ALL_CATEGORY_ID
        const className = cn(styles.row, {
          [styles.shaded]: isShaded,
          [styles.totalRow]: isTotal,
        })
        const handleClick = onClickItem && !isTotal ? () => onClickItem(isSelected ? null : id) : undefined

        return (
          <div
            key={ id }
            className={ className }
            onClick={ handleClick }
          >
            <div className={ styles.rowLabel }>
              { categoryName }
            </div>
            <div className={ styles.items }>
              <div className={ cn(styles.item, styles.member) } data-qa-marker='your'>{ itemsMember[idx].value }</div>
              { withComparison && (
                <div className={ cn(styles.item, styles.peers) } data-qa-marker='peers'> { itemsPeers[idx].value }</div>
              )}
              { withComparison && (
                <div className={ cn(styles.item, styles.others) } data-qa-marker='other'> { itemsOthers[idx].value }</div>
              )}
            </div>
          </div>
        )
      }) }
    </>
  )

export default CategoriesList
